import { Children, type ReactNode } from "react";
import { EmptyState } from "./UI";

export function DataTable({ className, children }: { className: string; children: ReactNode }) {
  return <div className={className} role="table">{children}</div>;
}

export function TableHead({ children }: { children: ReactNode }) {
  return <div className="table-head" role="row">{Children.map(children, (child) => <div role="columnheader">{child}</div>)}</div>;
}

export function TableRow({ children, onClick }: { children: ReactNode; onClick?: () => void }) {
  return <div className="table-row" role="row">{Children.map(children, (child, index) => (
    <div className="table-cell" role="cell">
      {onClick && index === 0 ? <button className="cell-link table-cell-link" onClick={onClick}>{child}</button> : child}
    </div>
  ))}</div>;
}

export function TableEmptyState({ title, text }: { title: string; text: string }) {
  return <div role="row"><div role="cell"><EmptyState title={title} text={text} /></div></div>;
}
